import { render } from "./AdventureIslandKoreaGlobalSettings.vue?vue&type=template&id=0360e927&scoped=true"
import script from "./AdventureIslandKoreaGlobalSettings.vue?vue&type=script&lang=js"
export * from "./AdventureIslandKoreaGlobalSettings.vue?vue&type=script&lang=js"

import "./AdventureIslandKoreaGlobalSettings.vue?vue&type=style&index=0&id=0360e927&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0360e927"]])

export default __exports__